import React from 'react';
import {ReactSVG} from 'react-svg';
import {addCoordinateSearchLayer, removeCoordinateSearchLayer, updateMapProperties} from '../../../actions';
import {connect} from 'react-redux';
import {trans} from '../../../config/translation';
import {pushGtmSearchCoordinate} from '../../../config/gtm';

/**
 * Coordinate search component
 * map will jump to designated coordinate when used
 */
class CoordinateSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            latitude: '',
            longitude: '',
        }
        this.updateLatitude = this.updateLatitude.bind(this);
        this.updateLongitude = this.updateLongitude.bind(this);
    }

    /**
     * input latitude change event handler
     *
     * @param evt
     */
    updateLatitude(evt) {
        this.setState({
            ...this.state,
            latitude: evt.target.value
        })
        // this.latitude = evt.target.value;
    }

    /**
     * input longitude change event handler
     *
     * @param evt
     */
    updateLongitude(evt) {
        this.setState({
            ...this.state,
            longitude: evt.target.value
        })
        // this.longitude = evt.target.value;
    }

    /**
     * go to coordinate handler
     */
    goToCoordinate() {
        // [94.4642473599928, -12.069960238304505, 151.49650319708428, 7.732906371796711]
        if (this.state.longitude !== '' && this.state.latitude !== '') {
            $('body').find('#location-search-dropdown-menu').removeClass('show');
            this.props.updateMapProperties({
                center: [this.state.longitude, this.state.latitude],
                zoom  : 8,
            });
            this.props.addCoordinateSearchLayer([this.state.latitude, this.state.longitude]);
        }
        /* gtm event processing */
        pushGtmSearchCoordinate();
    }

    resetSearch() {
        this.setState({
            latitude: '',
            longitude: '',
        });

        this.props.removeCoordinateSearchLayer();
    }

    render() {
        return (
            <div className="form-inline">
                <div className="input-material-placeholder">
                    <input type="text" className="form-control" placeholder=" "
                           id="search-latitude" value={this.state.latitude} onChange={this.updateLatitude} autoComplete={'off'}/>
                    <span className="placeholder">{trans('nav.find-location.latitude')}</span>
                </div>
                <div className="input-material-placeholder">
                    <input type="text" className="form-control" placeholder=" "
                           id="search-longitude" value={this.state.longitude} onChange={this.updateLongitude} autoComplete={'off'}/>
                    <span className="placeholder">{trans('nav.find-location.longitude')}</span>
                </div>
                {this.props.coordinateSearchLayer.status ?
                    <button className="btn" role="button"
                            onClick={() => this.resetSearch()}>
                        <ReactSVG className="location-finder-icon react-svg"
                                  src="/img/maps/icon/close.svg"/>
                    </button>
                    :
                    <button className="btn" role="button"
                            onClick={() => this.goToCoordinate()}>
                        <ReactSVG className="location-finder-icon react-svg"
                                  src="/img/maps/icon/search-icon.svg"/>
                    </button>
                }

            </div>
        );
    }
}

const mapActionToProps = {
    updateMapProperties,
    addCoordinateSearchLayer,
    removeCoordinateSearchLayer,
};

const mapStateToProps = state => {
    return {
        coordinateSearchLayer: state.coordinateSearchLayer,
    };
};

export default connect(mapStateToProps, mapActionToProps)(CoordinateSearch);